export var TransactionType;
(function (TransactionType) {
    TransactionType["PURCHASE"] = "PURCHASE";
    TransactionType["BILL_PAYMENT"] = "BILL_PAYMENT";
    TransactionType["MONEY_TRANSFER"] = "MONEY_TRANSFER";
    TransactionType["DISBURSEMENT"] = "DISBURSEMENT";
    TransactionType["P2P"] = "P2P";
})(TransactionType || (TransactionType = {}));
//# sourceMappingURL=TransactionType.js.map